import { Insurer } from '@getvim-os/standard';
import { Standard } from '@getvim/vim-connect';

const demographics: Standard.Entities.PatientDemographics = {
  firstName: 'Tony',
  lastName: 'Stark',
  dateOfBirth: '1970-05-29',
  gender: Standard.Entities.Gender.male,
  address: {
    fullAddress: 'Cana Rd, North Carolina 27028, USA',
    address1: 'Cana Rd',
    city: 'North Carolina',
    state: 'USA',
    zipCode: '27028',
  },
};

const insurance: Standard.Entities.PatientInsurance = {
  memberId: '999888777',
  groupId: '12345',
  ehrInsurance: 'Test',
  insurer: Insurer.UHC,
};

const contact_info: Standard.Entities.PatientContactInfo = {
  homePhoneNumber: '415-347-5430',
  email: 'h@getvim.com',
};

const pcp: Standard.Entities.Provider = {
  providerEhrId: '40598',
  npi: '1285171983',
  demographics: {
    firstName: 'SOLANGE',
    lastName: 'BAVUSO',
  },
  specialty: [
    {
      description: 'Nurse Practitioner',
    },
  ],
};

const problemList: Standard.Entities.Diagnosis[] = [
  {
    description: '(Induced) termination of pregnancy with other complications',
    code: 'O04.89',
  },
  { description: 'Irritable bowel disease', code: 'K58.9' },
];

const patientId: string = '111222';

export const tonyStark: Standard.Events.PatientInContextPayload = {
  patientId,
  demographics,
  insurance,
  contact_info,
  pcp,
  problemList,
};
